import React, { Component } from 'react'
import './index.less'
import GiftItem from '../GiftItem'

export default class extends Component {
  render() {
    const { giftList } = this.props
    return (
      <div className="gift-list">
        {
          giftList && giftList.map((item, index) => {
            return (
              <GiftItem
                key={index}
                name={item.name}
                goldNum={item.gold}
                giftImg={item.image}
              />
            )
          })
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/nationalTemplate/Gift/index.js